import { UtilitarioService } from "@app/services/utilitario.service";

export class FiltrosReceberRecebidas {

  ParticipanteId: number;
  TipoData: 'Vencimento' | 'Emissao' | 'Recebimento';
  DataInicial: string;
  DataFinal: string;
  ContaId: number;
  UnidadeId: number;
  Observacao: string;
  ProcessoId: number;

  constructor() {
    this.DataInicial = UtilitarioService.retornaDataAtualMaisDias(0);
    this.DataFinal = UtilitarioService.retornaDataAtualMaisDias(0);
  }

}